module.exports = __webpack_public_path__ + "onboarding-releases.cb103a3774a0cc4278022085ca006f88.hashedasset.svg";